"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODEL_TEXT_MIN_VERSION = exports.TextDialect = void 0;
exports.getTextDialectForCadTool = getTextDialectForCadTool;
exports.getModelTextCodec = getModelTextCodec;
exports.resolveDisplayText = resolveDisplayText;
exports.encodeStrippedText = encodeStrippedText;
exports.encodeRawText = encodeRawText;
exports.displayLength = displayLength;
exports.toPlainText = toPlainText;
exports.toUnicodeOverlineText = toUnicodeOverlineText;
exports.searchHaystack = searchHaystack;
const AltiumTextCodec_1 = require("../Parse/Altium/AltiumTextCodec");
const CadstromTextCodec_1 = require("../DataScience/signal-hygiene/CadstromTextCodec");
const KicadTextCodec_1 = require("../Parse/Kicad/KicadTextCodec");
const OrcadTextCodec_1 = require("../Parse/OrCAD/OrcadTextCodec");
var TextDialect;
(function (TextDialect) {
    TextDialect["None"] = "none";
    TextDialect["Orcad"] = "orcad";
    TextDialect["Altium"] = "altium";
    TextDialect["Kicad"] = "kicad";
    TextDialect["Cadstrom"] = "cadstrom";
})(TextDialect || (exports.TextDialect = TextDialect = {}));
exports.MODEL_TEXT_MIN_VERSION = '1.0.0';
function getTextDialectForCadTool(tool) {
    switch (tool) {
        case 'orcad':
            return TextDialect.Orcad;
        case 'altium':
            return TextDialect.Altium;
        case 'kicad':
            return TextDialect.Kicad;
        case 'cadstrom':
            return TextDialect.Cadstrom;
        case 'eagle':
        case 'allegro':
        case 'xpedition':
            return TextDialect.None;
    }
}
function getModelTextCodec(dialect) {
    switch (dialect) {
        case TextDialect.Orcad:
            return new OrcadTextCodec_1.OrcadTextCodec();
        case TextDialect.Altium:
            return new AltiumTextCodec_1.AltiumTextCodec();
        case TextDialect.Kicad:
            return new KicadTextCodec_1.KicadTextCodec();
        case TextDialect.Cadstrom:
            return new CadstromTextCodec_1.CadstromTextCodec();
        case TextDialect.None:
            return new NoneTextCodec();
    }
}
class NoneTextCodec {
    decode(raw) {
        return { text: raw, transforms: [] };
    }
}
function resolveDisplayText(source) {
    if (source.declarations?.overbar) {
        return { text: source.raw, transforms: [{ type: 'bar', from: 0, to: source.raw.length }] };
    }
    let text = source.raw;
    let transforms = [];
    for (const dialect of source.dialects) {
        const decoded = getModelTextCodec(dialect).decode(text);
        const offsets = offsetsAfterRemovals(text, decoded.text);
        transforms = remapBars(transforms, offsets);
        transforms.push(...decoded.transforms);
        text = decoded.text;
    }
    return { text, transforms: normalizeBarTransforms(transforms) };
}
function encodeStrippedText(source) {
    const display = resolveDisplayText(source);
    const textTransforms = display.transforms.filter(isBarTransform);
    return textTransforms.length > 0 ? { value: display.text, textTransforms } : { value: display.text };
}
function encodeRawText(source) {
    const display = resolveDisplayText(source);
    return {
        value: source.raw,
        textTransforms: [...replacementTransforms(source.raw, display.text), ...display.transforms.filter(isBarTransform)],
    };
}
function displayLength(source) {
    return resolveDisplayText(source).text.length;
}
function toPlainText(display) {
    return display.text;
}
function toUnicodeOverlineText(display) {
    const bars = display.transforms.filter(isBarTransform);
    let text = '';
    for (let index = 0; index < display.text.length; index++) {
        text += display.text[index];
        if (bars.some((bar) => index >= bar.from && index < bar.to)) {
            text += '\u0305';
        }
    }
    return text;
}
function searchHaystack(source) {
    return [...new Set([source.raw, toPlainText(resolveDisplayText(source))])];
}
function isBarTransform(transform) {
    return transform.type === 'bar';
}
function offsetsAfterRemovals(source, target) {
    const offsets = [];
    let targetIndex = 0;
    for (let index = 0; index < source.length; index++) {
        offsets.push(targetIndex);
        if (source[index] === target[targetIndex]) {
            targetIndex++;
        }
    }
    offsets.push(targetIndex);
    return offsets;
}
function remapBars(transforms, offsets) {
    return transforms.map((transform) => transform.type === 'bar' ? { ...transform, from: offsets[transform.from], to: offsets[transform.to] } : transform);
}
function normalizeBarTransforms(transforms) {
    const bars = transforms.filter(isBarTransform).sort((left, right) => left.from - right.from || left.to - right.to);
    const normalizedBars = [];
    for (const bar of bars) {
        const previous = normalizedBars.at(-1);
        if (previous && bar.from <= previous.to) {
            previous.to = Math.max(previous.to, bar.to);
        }
        else {
            normalizedBars.push({ ...bar });
        }
    }
    return [...transforms.filter((transform) => !isBarTransform(transform)), ...normalizedBars];
}
function replacementTransforms(source, display) {
    const transforms = [];
    let sourceIndex = 0;
    let displayIndex = 0;
    let outputIndex = 0;
    while (sourceIndex < source.length) {
        if (source[sourceIndex] === display[displayIndex]) {
            sourceIndex++;
            displayIndex++;
            outputIndex++;
            continue;
        }
        const start = outputIndex;
        let length = 0;
        while (sourceIndex < source.length && source[sourceIndex] !== display[displayIndex]) {
            sourceIndex++;
            length++;
        }
        transforms.push({ type: 'replace', start, length, value: '' });
    }
    return transforms;
}
//# sourceMappingURL=index.js.map